import { useEffect, useRef } from 'react';

export function useScrollToTopOnChange<T>(value: T): void {
  const previousValueRef = useRef(value);

  useEffect(() => {
    if (previousValueRef.current === value) return;
    previousValueRef.current = value;

    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    window.setTimeout(() => {
      root.style.scrollBehavior = previousScrollBehavior;
    }, 100);
  }, [value]);
}
